export const T = {
  en_GB: {
    productCosts: "Product Costs",
    portfolioCosts: "Portfolio Costs",
    manual: "Product Category Costs",
    currency: "Currency Costs",
  },
  nb_NO: {
    productCosts: "Produktkostnader",
    portfolioCosts: "Porteføljekostnader",
    manual: "Produktkategorikostnader",
    currency: "Valutakostnader",
  },
} as const;
